import React from 'react'
import { withRouter } from 'react-router-dom'
import { datadogLogs } from '@datadog/browser-logs'

import { currentLang, t } from 'translations'

const ErrorImage = {
  fr: 'https://cloud.merinio.com/generic_error_fr.png',
  en: 'https://cloud.merinio.com/generic_error_en.png'
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidMount() {
    // Listen on history change to reset error page
    const unlisten = this.props.history.listen(() => {
      if (this.state.hasError) this.setState({ hasError: false })
    })

    // Save history unlistener
    this.setState({ ...this.state, history: { unlisten } })
  }

  // Remove listener for history changes
  componentWillUnmount() {
    if (this.state.history && this.state.history.unlisten) this.state.history.unlisten()
  }

  componentDidCatch(err) {
    datadogLogs.logger.error(err.message, undefined, err)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="text-center pt-5">
          <h1>{t('SOMETHING_WENT_WRONG')}</h1>
          <img src={ErrorImage[currentLang()]} alt="Error" className="rounded mx-auto d-block img-fluid error-image pt-3" />
        </div>
      )
    }

    return this.props.children
  }
}

export default withRouter(ErrorBoundary)
